import { useState } from "react";
import { Check } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { api } from "@/lib/api";

const inputCls =
  "w-full bg-[#060b14] border border-white/15 px-4 py-3 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-[#2a5fdb] transition-colors";

export const WaitlistDialog = ({ open, onOpenChange }) => {
  const [form, setForm] = useState({ parent_name: "", email: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.parent_name.trim() || !form.email.trim() || submitting) return;
    setSubmitting(true);
    setError("");
    try {
      await api.post("/waitlist", form);
      setDone(true);
    } catch (err) {
      setError(
        err.response?.data?.detail?.[0]?.msg ||
          err.response?.data?.detail ||
          "Something went wrong — please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="waitlist-dialog"
        className="bg-[#0a1428] border-white/15 text-white sm:max-w-md"
      >
        {done ? (
          <div data-testid="waitlist-success" className="py-4">
            <div className="w-12 h-12 border border-[#2a5fdb] flex items-center justify-center mb-6">
              <Check className="text-[#2a5fdb]" />
            </div>
            <h3 className="font-display uppercase text-3xl tracking-tight leading-none">
              You're on <span className="text-[#2a5fdb]">the list.</span>
            </h3>
            <p className="mt-4 text-white/60 text-sm leading-relaxed">
              Owen will email you as soon as 2027 holiday camp dates and spots
              open up. You'll be first in line.
            </p>
          </div>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="font-display uppercase text-3xl tracking-tight leading-none text-left">
                Camps <span className="text-[#2a5fdb]">2027</span> waitlist
              </DialogTitle>
              <DialogDescription className="text-white/60 text-sm text-left">
                Drop your details and you'll be the first to hear when holiday
                camp spots open.
              </DialogDescription>
            </DialogHeader>
            <form onSubmit={submit} className="space-y-4 mt-2">
              <input
                data-testid="waitlist-input-name"
                className={inputCls}
                placeholder="Parent name *"
                value={form.parent_name}
                onChange={(e) => setForm({ ...form, parent_name: e.target.value })}
              />
              <input
                data-testid="waitlist-input-email"
                className={inputCls}
                type="email"
                placeholder="Email *"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
              {error && (
                <p data-testid="waitlist-error" className="text-red-400 text-sm">
                  {error}
                </p>
              )}
              <button
                data-testid="waitlist-submit"
                type="submit"
                disabled={!form.parent_name.trim() || !form.email.trim() || submitting}
                className="btn-sharp w-full justify-center disabled:opacity-40 disabled:cursor-not-allowed"
              >
                {submitting ? "Joining…" : "Join the waitlist"}
                <span aria-hidden>→</span>
              </button>
            </form>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
